import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["coreCustom", "coreFieldIdInput", "internalInput", "multipleChoiceInput", "nameInput"];
  }

  static get values() {
    return { multiChoiceCoreFieldIds: String };
  }

  connect() {
    // console.log("connected");
    this.configureFields();
  }

  configureFields() {
    if (this.creatingCustomField) {
      this.disableCoreFieldInput();
      this.enableMultiChoiceInput();
      this.enableInternalInput();
    } else {
      this.enableCoreFieldInput();

      if (this.multiChoiceCoreFieldSelected()) { 
        this.disableMultiChoiceInput();
      } else {
        this.enableMultiChoiceInput();
      }

      this.disableInternalInput();
    }
  }

  get creatingCustomField() {
    return this.coreCustomTarget.value === "custom";
  }

  enableCoreFieldInput() {
    this.coreFieldIdInputTarget.value = this.coreCustomTarget.value;
    this.coreFieldIdInputTarget.disabled = false;
    this.nameInputTarget.value = this.coreCustomTarget.options[this.coreCustomTarget.selectedIndex].text;
  }

  disableCoreFieldInput() {
    this.coreFieldIdInputTarget.disabled = true;
    this.nameInputTarget.value = null;
  }

  enableInternalInput() {
    this.internalInputTarget.disabled = false;
    this.internalInputTarget.closest("input").disabled = false;
    this.internalInputTarget.closest(".input-field").classList.remove("dn");
    this.internalInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = false;
  }

  disableInternalInput() {
    this.internalInputTarget.closest(".input-field").classList.add("dn");
    this.internalInputTarget.disabled = true;

    this.internalInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = true;
  }

  enableMultiChoiceInput() {
    this.multipleChoiceInputTarget.disabled = false;
    this.multipleChoiceInputTarget.closest(".input-field").classList.remove("dn");
    this.multipleChoiceInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = false;
  }

  disableMultiChoiceInput() {
    this.multipleChoiceInputTarget.closest(".input-field").classList.add("dn");
    this.multipleChoiceInputTarget.disabled = true;
    this.multipleChoiceInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = true;
  }

  get multiChoiceCoreFieldIds() {
    return this.multiChoiceCoreFieldIdsValue.split(" ");
  }

  multiChoiceCoreFieldSelected() {
    return this.multiChoiceCoreFieldIds.includes(this.coreCustomTarget.value);
  }
}


